module.exports = __webpack_public_path__ + "static/media/shield-icon.8970ac8c.svg";